/* Bloom Medical — theme behaviour */
(function () {
  'use strict';

  // Mobile navigation
  var burger = document.querySelector('.bm-burger');
  var mobileNav = document.getElementById('BmMobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  
  // Header dropdowns
  var dropItems = document.querySelectorAll('.bm-nav__item.has-sub');
  function closeAllDrops(focusToggle) {
    dropItems.forEach(function (item) {
      if (!item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      var t = item.querySelector('.bm-nav__toggle');
      if (t) {
        t.setAttribute('aria-expanded', 'false');
        if (focusToggle) t.focus();
      }
    });
  }
  if (dropItems.length) {
    dropItems.forEach(function (item) {
      var toggle = item.querySelector('.bm-nav__toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closeAllDrops(false);
        if (willOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.bm-nav__item.has-sub')) return;
      closeAllDrops(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrops(true);
    });
  }

  // Product gallery thumbnails
  var mainImage = document.getElementById('BmProductImage');
  var thumbs = document.querySelectorAll('.bm-product__thumbs button');
  if (mainImage && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImage.src = btn.getAttribute('data-full');
        thumbs.forEach(function (b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  // Variant selector -> price
  var select = document.getElementById('BmVariant');
  var priceEl = document.getElementById('BmPrice');
  if (select && priceEl) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var html = opt.getAttribute('data-price') || '';
      var compare = opt.getAttribute('data-compare');
      if (compare) html += ' <span class="was">' + compare + '</span>';
      priceEl.innerHTML = html;
    });
  }

  // Smooth in-page anchors (matches the Squarespace "Explore programmes" jump)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
